import {combineReducers} from "redux";

import profile from "./pages/profile/reducer";
import materials from "./pages/materials/reducer";
import screening from "./pages/screening/reducer";
import articles from "./pages/articles/reducer";

export default combineReducers({
  profile,
  materials,
  screening,
  articles,
})